<template>
  <div v-if="showDatePicker" class="is-flex">
    <div class="control is-flex">
      <label class="radio"><input class="radio-btn" type="radio" v-model="publishSelection" value="now">{{ $t('now') }}</label>
      <label class="radio"><input class="radio-btn" type="radio" v-model="publishSelection" value="later">{{ $t('laterDate') }}</label>
    </div>
    <div class="date-fields">
      <input v-if="publishSelection === 'later'" type="date" id="date" v-model="date" :min="dateToday">
      <input v-if="publishSelection === 'later'" type="time" v-model="time">
    </div>
    <button class="button is-primary is-small is-rounded" @click="emitPublish">Done</button>
  </div>
</template>

<script>

export default {
  components: {},
  props: ['showDatePicker'],
  data: function () {
    return {
      publishSelection: 'now',
      date: '',
      time: ''
    }
  },
  mounted: function () {
  },
  computed: {
    dateTime: function () {
      if (this.publishSelection === 'later') {
        return this.date + ' ' + this.time
      }
      return ''
    },
    dateToday: function () {
      var today = new Date()
      const year = today.getFullYear()
      let month = today.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      const day = today.getDate()
      return year + '-' + month + '-' + day
    }
  },
  methods: {
    emitPublish: function () {
      const isPrivate = this.publishSelection === 'later'

      this.$emit('publish', isPrivate, this.dateTime)
    }
  }
}
</script>

 <style lang="scss" scoped>
  @import '~styles/utils.scss';

  .button {
    margin: 0 0.1rem;
    @include mobile {
      margin: 0 0.1rem;
      font-size: 0.7rem;
    }
  }

  input[type="date"]::-webkit-clear-button, input[type="date"]::-webkit-inner-spin-button {
    display: none;
  }

  .control {
    font-size: 0.85rem;
    align-items: center;
    margin-right: 0.5rem;
  }
  .radio {
    margin: 0 0.25rem;
  }
  .radio-btn {
    margin-right: 0.25rem;
  }
</style>
